import { withTranslation } from "react-i18next";

import React from 'react';
import { Link } from 'react-router-dom';
import { Header } from '../Common/Header';
import { Footer } from '../Common/Footer';
import { Cart } from './Cart';
import { Collapse } from 'reactstrap';
import { Profile } from './Profile';
import Products from '../../Models/Products';
import StarRatingComponent from 'react-star-rating-component';
import StarRatings from 'react-star-ratings';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Spinner } from 'reactstrap';
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from 'react-responsive-carousel';
import AliceCarousel from 'react-alice-carousel';
import "react-alice-carousel/lib/alice-carousel.css";
import Common from "../../Models/Common";
class CategoriesDetails extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            id: '',
            collapse: false,
            modal: false,
            productDetails: [],
            favouriteDetails: [],
            sellerDetails: '',
            favouriteRemoveDetails: [],
            reviews: [],
            counter: '',
            image: '',
            description: '',
            flag: '',
            ratings: '',
            ratings: [],
            status: '',
            layer: '',
            single: [],
            multipleImage: [],
            multipleImages: [],
        };

        var x = parseInt(this.props.match.params.id, 16)
        // var id=(x-521)
        var id = this.props.match.params.id
        this.getDetails(this.props.match.params.id)
        this.getSellerDetails(this.props.match.params.id)
        this.getFavouriteCounterComp(this.props.match.params.id);
        this.getReview(this.props.match.params.id);
        this.getRating(this.props.match.params.id);
        this.getImage(this.props.match.params.id)
    }

    componentDidMount() {
        window.scrollTo(0, 0)
    }

    getSellerDetails(id) {
        Products.getProductsDetails(id).then(res => {
            res.data.seller.map(res =>
                this.setState({ sellerDetails: res.id })
            )
            this.setState({ status: res.data.status })
        })
    }

    getReview(id) {
        const x = JSON.parse(localStorage.getItem('info'))
        if (x === null || x === '') {
            Products.getReview(id, 0).then(res => {
                this.setState({ reviews: res.data.payload, flag: res.data.flag, ratings: res.data.overall, status: res.data.status })
            })
        } else {
            Products.getReview(id, x.id).then(res => {
                this.setState({ reviews: res.data.payload, flag: res.data.flag, ratings: res.data.overall, status: res.data.status })
            })
        }
    }

    getRating(id) {
        var x = JSON.parse(localStorage.getItem('info'))
        if (x === null) {
            Products.getReview(id, 0).then(res => {
                this.setState({ rating: res.data.overall, status: res.data.status })
            })
        } else {
            Products.getReview(id, x.id).then(res => {
                this.setState({ rating: res.data.overall, status: res.data.status })
            })
        }
    }

    getDetails(id) {
        const isMobile = window.innerWidth <= 500;
        const isTablet = window.innerWidth > 500 && window.innerWidth < 1200;
        const isDesktop = window.innerWidth >= 1200;
        //for mobile view
        if (isMobile) {
            Products.getProductsDetails(id, 3).then(res => {
                if (res.data.multiples.length < 3 && res.data.multiples.length > 0) {
                    res.data.multiples.push({
                        img: res.data.product[0].img
                    })
                    this.setState({ productDetails: res.data.product, status: res.data.status, single: res.data.product_single, multipleImage: res.data.multiples, layer: res.data.multiples.length })
                } else {
                    this.setState({ productDetails: res.data.product, status: res.data.status, single: res.data.product_single, multipleImage: res.data.multiples, layer: res.data.multiples.length })
                }
            })
        }
        //for tablet view
        else if (isTablet) {
            Products.getProductsDetails(id, 2).then(res => {
                if (res.data.multiples.length < 4 && res.data.multiples.length > 0) {
                    res.data.multiples.push({
                        img: res.data.product[0].img
                    })
                    this.setState({ productDetails: res.data.product, status: res.data.status, single: res.data.product_single, multipleImage: res.data.multiples, layer: res.data.multiples.length })
                } else {
                    this.setState({ productDetails: res.data.product, status: res.data.status, single: res.data.product_single, multipleImage: res.data.multiples, layer: res.data.multiples.length })
                }
            })
        }
        //for desktop view
        else if (isDesktop) {
            Products.getProductsDetails(id, 1).then(res => {
                if (res.data.multiples.length <= 5 && res.data.multiples.length > 0) {
                    res.data.multiples.push({
                        img: res.data.product[0].img
                    })
                    this.setState({ productDetails: res.data.product, status: res.data.status, single: res.data.product_single, multipleImage: res.data.multiples, layer: res.data.multiples.length })
                } else {
                    this.setState({ productDetails: res.data.product, status: res.data.status, single: res.data.product_single, multipleImage: res.data.multiples, layer: res.data.multiples.length })
                }
            })
        }
    }

    getImage(id) {
        const isMobile = window.innerWidth <= 500;
        const isTablet = window.innerWidth > 500 && window.innerWidth < 1200;
        const isDesktop = window.innerWidth >= 1200;
        //for mobile view
        if (isMobile) {
            Products.getProductsDetails(id, 3).then(res => {
                res.data.multiples.push({
                    img: res.data.product[0].img
                })
                this.setState({ multipleImages: res.data.multiples })
            })
        }
        //for tablet view
        else if (isTablet) {
            Products.getProductsDetails(id, 2).then(res => {
                res.data.multiples.push({
                    img: res.data.product[0].img
                })
                this.setState({ multipleImages: res.data.multiples })
            })
        }
        //for desktop view
        else if (isDesktop) {
            Products.getProductsDetails(id, 1).then(res => {
                res.data.multiples.push({
                    img: res.data.product[0].img
                })
                this.setState({ multipleImages: res.data.multiples })
            })
        }
    }

    toggle() {
        this.setState({ collapse: !this.state.collapse });
    }

    toggleAll() {
        this.setState(prevState => ({
            modal: !prevState.modal
        }));
    }

    getFavouriteCounterComp(id) {
        let x = JSON.parse(localStorage.getItem('info'));
        if (x !== null) {
            Products.getFavouriteCounter(id, x.id).then(res => {
                this.setState({
                    favouriteDetails: res.data.flag,
                    counter: res.data.payload,
                    status: res.data.status
                })
            })
        } else {
            Products.getFavouriteCounter(id, 0).then(res => {
                this.setState({
                    favouriteDetails: res.data.flag,
                    counter: res.data.payload, status: res.data.status
                })
            })
        }
    }

    handleFavourite() {
        var x = JSON.parse(localStorage.getItem('info'))
        Products.getFavourite(this.props.match.params.id, x.id).then(res => {
            this.setState({
                favouriteDetails: res.data.flag,
                counter: this.state.counter + 1, status: res.data.status
            })
        })
    }

    handleRemoveFavourite() {
        var x = JSON.parse(localStorage.getItem('info'))
        Products.getRemoveFavourite(this.props.match.params.id, x.id).then(res => {
            this.setState({ favouriteDetails: res.data.flag, counter: this.state.counter - 1, status: res.data.status })
        })
    }

    handleShowFavouriteMessage() {
        alert(this.props.t('0'))
    }

    favourite() {
        if ((localStorage.getItem('info')) === null || (localStorage.getItem('info')) === '') {
            return (
                <div>
                    <Button className="btn btn-secondary" style={{ backgroundColor: '#ccc', border: '1px solid #ccc', width: '110px' }} onClick={this.toggleAll.bind(this)}>{this.props.t('2')}</Button>
                    <Modal isOpen={this.state.modal} toggle={this.toggleAll.bind(this)} className={this.props.className}>
                        <ModalHeader toggle={this.toggleAll.bind(this)}></ModalHeader>
                        <ModalBody>
                            {this.props.t('1')}
                        </ModalBody>
                        <ModalFooter>
                            <Button color="danger" onClick={this.toggleAll.bind(this)}>{this.props.t('8')}</Button>
                        </ModalFooter>
                    </Modal>
                </div >

            )
        } else {
            var x = JSON.parse(localStorage.getItem('info'))
            if (x.id === this.state.sellerDetails) {
                return (
                    <div>
                        <button className="btn btn-secondary" style={{ backgroundColor: '#ccc', border: '1px solid #ccc', width: '110px' }} onClick={this.handleShowFavouriteMessage.bind(this)}>{this.props.t('2')}</button>
                    </div>
                )
            } else {
                if (this.state.favouriteDetails === 1) {
                    return (
                        <div>
                            <button className="btn btn-secondary" style={{ backgroundColor: '#ccc', border: '1px solid #ccc', width: '110px' }} onClick={this.handleFavourite.bind(this)}>{this.props.t('2')}</button>
                        </div>
                    )
                } else {
                    return (
                        <div>
                            <button className="btn btn-secondary" style={{ backgroundColor: '#ccc', border: '1px solid #ccc', width: '110px' }} onClick={this.handleRemoveFavourite.bind(this)}><i className="fas fa-heart mr-1" style={{ color: 'red' }} ></i> {this.props.t('5')}</button>
                        </div>
                    )
                }
            }
        }
    }

    onRead(des, details) {
        const renderHTML = (rawHTML) => React.createElement("div", { dangerouslySetInnerHTML: { __html: rawHTML } });
        if (this.state.collapse === true) {
            return (
                <div onClick={this.toggle.bind(this)} style={{ cursor: 'pointer' }}>
                    <Collapse isOpen={this.state.collapse}>{renderHTML(details)}</Collapse>
                    <i className="fas fa-angle-up"></i></div>
            )
        } else {
            return (<div onClick={this.toggle.bind(this)} style={{ cursor: 'pointer' }}>{renderHTML(des)}{this.props.t('6')}</div>
            )
        }
    }

    details(details) {
        if (details === null || details === '') {
            return (
                <div>
                    <span>{details}<span id="dots">
                    </span> <Collapse isOpen={this.state.collapse}>{details}</Collapse></span>
                    {this.onRead()}
                </div>
            )
        } else {
            return (
                <div>
                    <span>{details.substr(0, 50)}
                        {/* <span id="dots"></span> */}
                        <Collapse isOpen={this.state.collapse}>{details}</Collapse>
                    </span>
                    {/* <div onClick={this.toggle.bind(this)} className="mt-2" style={{ marginBottom: '1rem' }}>{this.props.t('6')}</div> */}
                    {this.onRead()}
                </div>
            )
        }
    }

    handleClickButton(i, j) {
        const isMobile = window.innerWidth <= 500;
        const isTablet = window.innerWidth > 500 && window.innerWidth < 1200;
        const isDesktop = window.innerWidth >= 1200;
        //for mobile view
        if (isMobile) {
            console.log(j)
            Products.getProductsImage(i, j, 3).then(res => {
                if (res.data.images != null) {
                    if (res.data.images.length < 3) {
                        console.log(res.data.images)
                        res.data.images.push({
                            img: this.state.productDetails[0].img
                        })
                        this.setState({ multipleImage: res.data.images, layer: 1  })
                    } else {
                        this.setState({ multipleImage: res.data.images, layer: j + 3 })
                    }
                    console.log(this.state.multipleImage)
                }
                console.log(this.state.layer)
            })
            // if (j === 6) {
            //     Products.getProductsImage(i, j, 3).then(res => {
            //         if (res.data.images != null) {
            //             this.setState({ multipleImage: res.data.images ,layer: 9 })
            //         } else {
            //             console.log(res.data.image)
            //             this.setState({ layer: 3 })
            //         }
            //     })
            //     // this.setState({ layer: 9 })
            // } else if (j === 1) {
            //     Products.getProductsImage(i, j, 3).then(res => {
            //         if (res.data.images != null) {
            //             this.setState({ multipleImage: res.data.images })
            //         }
            //     })
            //     this.setState({ layer: 3 })
            // } else if (j === 3) {
            //     Products.getProductsImage(i, j, 3).then(res => {
            //         if (res.data.images != null) {
            //             this.setState({ multipleImage: res.data.images ,layer: 6 })
            //         }
            //         else {
            //             this.setState({ layer: 3 })
            //         }
            //     })
            //     // this.setState({ layer: 6 })
            // } else if (j === 9) {
            //     Products.getProductsImage(i, j, 3).then(res => {
            //         if (res.data.images != null) {
            //             res.data.images.push({
            //                 img: this.state.productDetails[0].img
            //             })
            //             this.setState({ multipleImage: res.data.images,layer:1 })
            //         }else {
            //             console.log(res.data.image)
            //             this.setState({ layer: 3 })
            //         }
            //     })
            //     this.setState({ layer: 1 })
            // }
        } else if (isTablet) {
            if (j === 6) {
                Products.getProductsImage(i, j, 2).then(res => {
                    if (res.data.images != null) {
                        // if (res.data.images.length < 10 && res.data.images.length > 5) {
                        //     res.data.images.push({
                        //         img: this.state.productDetails[0].img
                        //     })
                        //     this.setState({ multipleImage: res.data.images })
                        // } else {
                        res.data.images.push({
                            img: this.state.productDetails[0].img
                        })
                        this.setState({ multipleImage: res.data.images })
                        // }
                    }
                })
                this.setState({ layer: 1 })
            } else if (j === 1) {
                Products.getProductsImage(i, j, 2).then(res => {
                    if (res.data.images != null) {
                        this.setState({ multipleImage: res.data.images })
                    }
                })
                this.setState({ layer: 6 })
            }
        } else if (isDesktop) {
            if (j === 6) {
                Products.getProductsImage(i, j, 1).then(res => {
                    console.log(res.data.images)
                    console.log(j)
                    if (res.data.images != null) {
                        // if (res.data.images.length < 10 && res.data.images.length > 5) {
                        //     res.data.images.push({
                        //         img: this.state.productDetails[0].img
                        //     })
                        //     this.setState({ multipleImage: res.data.images })
                        // } else {
                        res.data.images.push({
                            img: this.state.productDetails[0].img
                        })
                        this.setState({ multipleImage: res.data.images })
                        // }
                    }
                })
                this.setState({ layer: 1 })
            } else if (j === 1) {
                Products.getProductsImage(i, j, 1).then(res => {
                    console.log(res.data.images)
                    if (res.data.images != null) {
                        this.setState({ multipleImage: res.data.images })
                    }
                })
                this.setState({ layer: 6 })
            }
        }
    }

    handleClick(img) {
        this.setState({ image: img })
    }

    imageShow(i) {
        const isMobile = window.innerWidth <= 500;
        const isDesktop = window.innerWidth >= 500;
        //for mobile view
        if (isMobile) {
            if (this.state.image) {
                return (
                    <div className="col-md-12" style={{ paddingLeft: '0px', paddingRight: '9px' }}>
                        <img src={Common.baseUrl + this.state.image} className="img-responsive" alt="" height="100%" width="100%" />
                    </div>
                )
            } else {
                return (
                    <div className="col-md-12" style={{ paddingLeft: '0px', paddingRight: '9px' }}>
                        <img src={Common.baseUrl + i} className="img-responsive" alt="" height="100%" width="100%" />
                    </div>
                )
            }
        }
        //for desktop view
        else if (isDesktop) {
            if (this.state.image) {
                return (
                    <div className="col-md-12" style={{ paddingLeft: '0px', paddingRight: '12px' }}>
                        <img src={Common.baseUrl + this.state.image} className="img-responsive" alt="" height="100%" width="100%" />
                    </div>
                )
            } else {
                return (
                    <div className="col-md-12" style={{ paddingLeft: '0px', paddingRight: '12px' }}>
                        <img src={Common.baseUrl + i} className="img-responsive" alt="" height="100%" width="100%" />
                    </div>
                )
            }
        }
    }

    multipleImageShow(id) {
        const isMobile = window.innerWidth <= 500;
        const isDesktop = window.innerWidth >= 500;
        //for mobile view
        if (isMobile) {
            if (this.state.multipleImage.length > 0) {
                return (
                    <div className="row" style={{ marginLeft: '0px', marginRight: '0px', height: '91px' }}>
                        {this.state.multipleImage.map((res, i) =>
                            <div className="pb-2" key={res.id} style={{ paddingLeft: '0px', paddingRight: '6px', width: '33%' }} onClick={this.handleClick.bind(this, res.img)}>
                                <img src={Common.baseUrl + res.img} className="img-responsive " alt="" height="85" width="100%" style={{ objectFit: 'cover', border: '1px solid #ccc' }} />
                            </div>
                        )}
                        {this.suffleButton(id, this.state.layer)}
                        <div>&nbsp;</div>
                    </div>
                )
            } else {
                return (
                    <div className=""></div>
                )
            }
        } else if (isDesktop) {
            if (this.state.multipleImage.length > 0) {
                return (
                    <div className="row" style={{ marginLeft: '0px', marginRight: '0px', height: '100px' }}>
                        {this.state.multipleImage.map((res, i) =>
                            <div className="pb-2" key={res.id} style={{ paddingLeft: '0px', paddingRight: '6px' }} onClick={this.handleClick.bind(this, res.img)}>
                                <img src={Common.baseUrl + res.img} className="img-responsive " alt="" height="94" width="100" style={{ objectFit: 'cover', border: '1px solid #ccc' }} />
                            </div>
                        )}
                        {this.suffleButton(id, this.state.layer)}
                        <div>&nbsp;</div>
                    </div>
                )
            } else {
                return (
                    <div className=""></div>
                )
            }
        }
    }

    suffleButton(id, layer) {
        console.log(layer)
        const isMobile = window.innerWidth <= 500;
        const isDesktop = window.innerWidth >= 500;
        //for mobile view
        if (isMobile) {
            if (this.state.multipleImages.length > 0 && this.state.multipleImages.length > 3) {
                console.log(this.state.multipleImages.length)
                return (
                    <div id="div1" className="mb-2 mobile_image_next_button" style={{ marginLeft: '485px', cursor: "pointer", opacity: '.75', zIndex: '200', position: "absolute" }} onClick={this.handleClickButton.bind(this, id, layer)}>
                        <img alt="" src={require('../../assets/images/arrow2.png')} className="rounded-circle" style={{ height: '23px', width: '23px', marginTop: '35px', verticalAlign: 'middle' }} />
                    </div>
                )
            } else {
                return (
                    <div className="" style={{ zIndex: '200', position: "relative" }}></div>
                )
            }
        }
        //for desktop view
        else if (isDesktop) {
            if (this.state.multipleImages.length > 0 && this.state.multipleImages.length > 5) {
                return (
                    <div id="div1" className="mb-2 mobile_image_next_button" style={{ marginLeft: '480px', cursor: "pointer", opacity: '.75', zIndex: '200', position: "absolute" }} onClick={this.handleClickButton.bind(this, id, layer)}>
                        <img alt="" src={require('../../assets/images/arrow2.png')} className="rounded-circle" style={{ height: '23px', width: '23px', marginTop: '35px', verticalAlign: 'middle' }} />
                    </div>
                )
            } else {
                return (
                    <div className="" style={{ zIndex: '200', position: "relative" }}></div>
                )
            }
        }
    }

    render() {
        const isMobile = window.innerWidth <= 500;
        var x = parseInt(this.props.match.params.id, 16)
        if (this.state.status === 200) {
            if (isMobile) {
                return (
                    <div>
                        <Header />
                        <div className="col-md-12 tr_blank_medium mt-5 pt-2"> </div>
                        <div className="col-md-12 tr_blank_medium mt-5 "> </div>
                        <div className="container_fluid">
                            <div className="">
                                <div className="col-md-1"></div>
                                <div className="col-md-7">
                                    {/* {this.state.productDetails.map(res =>
                                        <div className="" key={res.id}>
                                            <span style={{ fontsize: '9px' }}>
                                                <Link to={{
                                                    pathname: `/categories/${res.category_id}`,
                                                    state: { id: res.category_id }
                                                }} style={{ textDecoration: 'none' }} className="category-right">
                                                    {res.category_main} /
                                                        </Link>
                                                <Link to={{
                                                    pathname: `/sub-categories/${res.sub_category_id}`,
                                                    state: { id: res.sub_category_id }
                                                }} style={{ textDecoration: 'none', }} className="category-right">
                                                    {res.category_sub}
                                                </Link>
                                            </span>
                                        </div>
                                    )} */}
                                    {/* <div>&nbsp;</div> */}
                                    <div className="">
                                        <div className="row">
                                            <div className="col-md-11">
                                                <div className="row">
                                                    {this.state.productDetails.map(res =>
                                                        <div key={res.id}>
                                                            <div className="col-md-12">
                                                                <div className="big_font" style={{ fontSize: '20px' }}>
                                                                    <span>{res.title}</span>
                                                                </div>
                                                                <div className="product_mini_text" style={{ fontSize: '13px' }}>
                                                                    {res.short_desc}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>
                                                <div className="text-right">
                                                    <div className="width_100">
                                                        <div className="like" style={{ width: '100%' }}>
                                                            <div className="row ">
                                                                <div className="col-md-8 stars ">
                                                                    <StarRatings
                                                                        rating={this.state.rating}
                                                                        starDimension="20px"
                                                                        starSpacing="5px"
                                                                        starRatedColor="#FFD700"
                                                                    />
                                                                </div>
                                                                <div className="col-md-4 mt-2 text-right">
                                                                    <div className="row ml-0" >
                                                                        <div className="">
                                                                            {this.favourite()}
                                                                        </div>
                                                                        <div className="text-center ml-1" style={{ backgroundColor: '#ccc', border: '1px solid #ccc', width: '55px', height: '38px', padding: '8px', borderRadius: '5px' }}>
                                                                            {this.state.counter}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <hr style={{ width: "97%", marginTop: '6px', marginBottom: '6px' }} />
                                                {this.state.productDetails.map(res =>
                                                    <div key={res.id}>
                                                        {this.multipleImageShow(res.id)}
                                                        {/* <div className="row" style={{ marginLeft: '0px', marginRight: '0px', height: '91px' }}>
                                                            {this.state.multipleImage.map((res, i) =>
                                                                <div className="pb-2" key={res.id} style={{ paddingLeft: '0px', paddingRight: '6px', width: '33%' }} onClick={this.handleClick.bind(this, res.img)}>
                                                                    <img src={res.img} className="img-responsive " alt="" height="85" width="100%" style={{ objectFit: 'cover', border: '1px solid #ccc' }} />
                                                                </div>
                                                            )}
                                                            {this.suffleButton(res.id, this.state.layer)}
                                                            <div>&nbsp;</div>
                                                        </div> */}
                                                        {this.imageShow(res.img)}
                                                        <div>&nbsp;</div>
                                                        <div className="content_details card" style={{ border: '0px solid', fontSize: '13px' }}>
                                                            <div className="">
                                                                {this.onRead(res.trimed_long_desc, res.long_desc)}
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}
                                                <div>&nbsp;</div>
                                                <div className="main_rev">
                                                    <div>
                                                        {this.state.reviews.map(res =>
                                                            <div key={res.id} style={{ fontSize: '13px' }}>
                                                                <div className="special_width_2"></div>
                                                                <div className="">
                                                                    <div className="review_box col-md-9" style={{ width: '100%', border: '1px solid #ccc', borderRadius: '5px' }}>
                                                                        <div className="row">
                                                                            <div className="col-7">
                                                                                <span> {res.buyer}</span>
                                                                            </div>
                                                                            <div className="col-5" style={{ textAlign: 'end' }}>
                                                                                <span className="font_12" >{(JSON.stringify(res.created_at)).substring(1, 11)}</span><br />
                                                                            </div>
                                                                        </div>
                                                                        <div className="">
                                                                            <span className="">
                                                                                <StarRatingComponent
                                                                                    name="rate1"
                                                                                    starCount={5}
                                                                                    value={res.stars}
                                                                                />
                                                                            </span>
                                                                        </div>
                                                                        <div className="">
                                                                            <span className="">{res.comment.split('\n').map(function (item, key) {
                                                                                return (
                                                                                    <span key={key}>
                                                                                        {item}
                                                                                        <br />
                                                                                    </span>
                                                                                )
                                                                            })}
                                                                            </span>
                                                                            <br />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <br />
                                                            </div>
                                                        )}
                                                    </div>
                                                    <div>&nbsp;</div>
                                                    <div>&nbsp;</div>
                                                </div>
                                            </div>
                                            <div className="col-md-1"></div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <Cart state={{
                                        id: this.props.match.params.id,
                                        available: this.state.single.no_of_order_at_atime
                                    }} />
                                    <Profile id={this.props.match.params.id} />
                                </div>
                                <div className="col-md-1"></div>
                            </div>
                        </div>
                        <Footer className="mt-3" />
                    </div>
                )
            } else {
                return (
                    <div>
                        <Header />
                        <div className="col-md-12 tr_blank_medium mt-5 pt-4"> </div>
                        <div className="col-md-12 tr_blank_medium mt-5 "> </div>
                        <div className="container_fluid">
                            <div className="container">
                                <div className="col-md-12">
                                    <div className="row">
                                        <div className="col-md-1"></div>
                                        <div className="col-md-7">
                                            {/* {this.state.productDetails.map(res =>
                                                <div className="col-md-12 font_12 pb-2" key={res.id}>
                                                    <span>
                                                        <Link to={{
                                                            pathname: `/categories/${res.category_id}`,
                                                            state: { id: res.category_id }
                                                        }} style={{ textDecoration: 'none' }} className="category-right">
                                                            {res.category_main} /
                                                        </Link>
                                                        <Link to={{
                                                            pathname: `/sub-categories/${res.sub_category_id}`,
                                                            state: { id: res.sub_category_id }
                                                        }} style={{ textDecoration: 'none', }} className="category-right">
                                                            {res.category_sub}
                                                        </Link>
                                                    </span>
                                                </div>
                                            )} */}
                                            {/* <div>&nbsp;</div> */}
                                            <div className="col-md-12">
                                                <div className="row">
                                                    <div className="col-md-11">
                                                        {/* <div className="col-md-12"> */}
                                                        <div className="row">
                                                            {this.state.productDetails.map(res =>
                                                                <div key={res.id}>
                                                                    <div className="col-md-12">
                                                                        <div className="big_font" style={{ fontSize: '20px' }}>
                                                                            <span>{res.title}</span>
                                                                        </div>
                                                                        <div className="product_mini_text" style={{ fontSize: '15px' }}>
                                                                            {res.short_desc}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            )}
                                                        </div>
                                                        {/* </div> */}
                                                        <div className="second_line text-right" style={{ borderBottom: '0px solid', paddingBottom: '0px' }}>
                                                            <div className="width_100">
                                                                <div className="like col-md-12" style={{ width: '100%', paddingLeft: '0px' }}>
                                                                    <div className="row ">
                                                                        <div className="col-md-8 stars ">
                                                                            <StarRatings
                                                                                rating={this.state.rating}
                                                                                starDimension="20px"
                                                                                starSpacing="5px"
                                                                                starRatedColor="#FFD700"
                                                                            />
                                                                        </div>
                                                                        <div className="col-md-4 text-right">
                                                                            <div className="row " style={{ paddingLeft: '2px' }}>
                                                                                <div className="">
                                                                                    {this.favourite()}
                                                                                </div>
                                                                                <div className="text-center ml-1" style={{ padding: '8px', backgroundColor: '#ccc', border: '1px solid #ccc', width: '55px', height: '38px', borderRadius: '5px' }}>
                                                                                    {this.state.counter}
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <hr style={{ borderTop: '1px solid #ccc', width: '98%', marginBottom: '6px', marginTop: '6px' }}></hr>
                                                        {this.state.productDetails.map(res =>
                                                            <div key={res.id}>
                                                                {this.multipleImageShow(res.id)}
                                                                {/* <div className="row" style={{ marginLeft: '0px', marginRight: '0px', height: '100px' }}>
                                                                    {this.state.multipleImage.map((res, i) =>
                                                                        <div className="pb-2" key={res.id} style={{ paddingLeft: '0px', paddingRight: '6px' }} onClick={this.handleClick.bind(this, res.img)}>
                                                                            <img src={res.img} className="img-responsive " alt="" height="94" width="100" style={{ objectFit: 'cover', border: '1px solid #ccc' }} />
                                                                        </div>
                                                                    )}
                                                                    {this.suffleButton(res.id, this.state.layer)}
                                                                </div> */}
                                                                {this.imageShow(res.img)}
                                                                <div>&nbsp;</div>
                                                                <div className="content_details card" style={{ border: '0px solid', fontSize: '13px' }}>
                                                                    <div className="">
                                                                        {this.onRead(res.trimed_long_desc, res.long_desc)}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )}
                                                        {/* {this.state.productDetails.map(res =>
                                                            <div key={res.id}>
                                                                <div className="row" style={{ marginLeft: '0px', marginRight: '0px', zIndex: '-1' ,height:'110px'}}>
                                                                    {this.state.multipleImage.map((res, i) =>
                                                                        <div className="pb-2 " key={res.id} style={{ paddingLeft: '0px', paddingRight: '12px', zIndex: '-1' }} onClick={this.handleClick.bind(this, res.img)}>
                                                                            <img src={res.img} className="img-responsive " alt="" height="94" width="95" style={{ objectFit: 'cover', border: '1px solid #ccc' }} />
                                                                        </div>
                                                                    )}
                                                                    {this.suffleButton(res.id, this.state.layer)}
                                                                    <div>&nbsp;</div>
                                                                </div>
                                                                {this.imageShow(res.img)}
                                                                <div>&nbsp;</div>
                                                                <div>&nbsp;</div>
                                                                <div className="content_details card" style={{ border: '0px solid' }}>
                                                                    <div className="card-body">
                                                                        {this.onRead(res.trimed_long_desc, res.long_desc)}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )} */}
                                                        <div>&nbsp;</div>

                                                        <div>&nbsp;</div>
                                                        <div className="main_rev">
                                                            <div>&nbsp;</div>
                                                            <div>&nbsp;</div>
                                                            <div>
                                                                <div>
                                                                    {this.state.reviews.map(res =>
                                                                        <div key={res.id}>
                                                                            <div className="special_width_2"></div>
                                                                            <div className="row">
                                                                                <div className="special_width col-md-2 mr-3 " style={{ paddingRight: '0px', textAlign: 'center' }}>
                                                                                    <img src={Common.baseUrl + res.img_buyer} className="img-responsive  rounded-circle" alt="" width="80" height="80" style={{ objectFit: 'cover' }} />&nbsp;&nbsp;
                                                                                </div>
                                                                                <div className="review_box col-md-9" style={{ width: '100%', border: '1px solid #ccc', borderRadius: '5px' }}>
                                                                                    <div className="row">
                                                                                        <div className="col-md-8">
                                                                                            <span> {res.buyer}</span>
                                                                                        </div>
                                                                                        <div className="col-md-4">
                                                                                            <span className="ml-2">
                                                                                                <StarRatingComponent
                                                                                                    name="rate1"
                                                                                                    starCount={5}
                                                                                                    value={res.stars}
                                                                                                />
                                                                                            </span>
                                                                                        </div>
                                                                                    </div>
                                                                                    <div className="mb-1">
                                                                                        <span className="font_12" >{(JSON.stringify(res.created_at)).substring(1, 11)}</span><br />
                                                                                    </div>
                                                                                    <div className="">
                                                                                        <span className="">{res.comment.split('\n').map(function (item, key) {
                                                                                            return (
                                                                                                <span key={key}>
                                                                                                    {item}
                                                                                                    <br />
                                                                                                </span>
                                                                                            )
                                                                                        })}
                                                                                        </span>
                                                                                        <br />
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                            <br />
                                                                            {/* </d> */}
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            </div>
                                                            <div>&nbsp;</div>
                                                            <div>&nbsp;</div>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-1"></div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <Cart state={{
                                                id: this.props.match.params.id,
                                                available: this.state.single.no_of_order_at_atime
                                            }} />
                                            <Profile id={this.props.match.params.id} />
                                        </div>
                                        <div className="col-md-1"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <Footer className="mt-3" />
                    </div>
                )
            }
        } else {
            return (
                <div className="container-fluid">
                    <div className="container">
                        <div className="" style={{ height: '380px' }}></div>
                        <div className="text-center mt-3">
                            <Spinner color="primary" size="150" />
                        </div>
                    </div>
                </div>
            )
        }
    }
}
export { CategoriesDetails }


 CategoriesDetails = withTranslation('src_Components_CategoriesDetails_CategoriesDetails')(CategoriesDetails);